var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-bar padding-cu"},[_c('van-icon',{attrs:{"name":"arrow-left","size":"20"},on:{"click":_vm.goBack}}),_c('span',{staticClass:"title text-lg"},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }